function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "c0rarznota",
  colorInterpolationFilters: "auto"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.486275 0 0 0 0 0.501961 0 0 0 0 0.517647 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#c0rarznota)",
  transform: "translate(-932 -526) translate(932 526)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B6BDC3",
  fillRule: "nonzero",
  d: "M12.5 15.352c-1.083 0-2.085-.345-2.899-.93l1.659-1.636c.37.196.791.307 1.24.307 1.453 0 2.63-1.162 2.63-2.593 0-.442-.112-.858-.31-1.222l1.658-1.635c.594.802.944 1.789.944 2.857 0 2.68-2.204 4.852-4.922 4.852M7.578 10.5c0-2.68 2.204-4.852 4.922-4.852 1.083 0 2.085.345 2.899.93L13.74 8.215c-.37-.196-.791-.307-1.24-.307-1.453 0-2.63 1.162-2.63 2.593 0 .442.112.858.31 1.222l-1.658 1.635c-.594-.802-.944-1.789-.944-2.857m11.654-5.572l3.92-3.864L22.071 0 17.74 4.27c-1.417-.524-3.061-.858-4.95-.858C4.103 3.412 0 10.494 0 10.494s1.867 3.387 5.867 5.48l-4.018 3.962L2.928 21l4.42-4.357c1.49.574 3.217.945 5.194.945 8.63 0 12.458-7.094 12.458-7.094s-1.735-3.486-5.768-5.566"
}))));

var SvgIconsGlobalVisibleGrayHidden = function SvgIconsGlobalVisibleGrayHidden(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconsGlobalVisibleGrayHidden, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons-global-visible-gray-hidden.83095ef2.svg";
export { ForwardRef as ReactComponent };